import { Skeleton } from '@/components/shadcn/skeleton'
import { Suspense } from 'react'
import { HeaderFilterContent } from '../Filter'
import { useFiltersLayout } from '../FiltersLayoutContext'
import { QueryErrorBoundary } from '../../QueryErrorBoundary'

export function HeaderFilters({ actionsRef }: { actionsRef: React.RefObject<HTMLDivElement> }) {
  const { pinnedFilters } = useFiltersLayout()

  return (
    <QueryErrorBoundary errorMessage={<span>Failed to fetch filters</span>}>
      <Suspense fallback={<HeaderFiltersLoading />}>
        <HeaderFilterContent pinnedFilters={pinnedFilters} actionsRef={actionsRef} />
      </Suspense>
    </QueryErrorBoundary>
  )
}

function HeaderFiltersLoading() {
  return (
    <div className="flex flex-1 flex-wrap items-center justify-between gap-2">
      <div className="flex gap-2">
        <Skeleton className="h-6 w-[200px]" />
        <Skeleton className="h-6 w-[200px]" />
      </div>
      <div className="flex gap-2">
        <Skeleton className="h-6 w-[200px]" />
        <Skeleton className="h-6 w-[200px]" />
      </div>
    </div>
  )
}
